module.exports = __webpack_public_path__ + "img/personal-social-posts.61e4b7a5.png";